import s from "./style.module.css";
import React, {useEffect, useState} from "react";
import {Checkbox, CircularProgress, MenuItem, Select} from "@mui/material";
import api from "../../api/api";
import openEye from "../../assets/eye-open-svgrepo-com.svg"
import closeEye from "../../assets/eye-close-svgrepo-com.svg"
import {toast} from "react-toastify";

const AgeGroupAddition = () => {

    const [ageGroups, setAgeGroups] = useState([]);
    const [ageGroupsCRM, setAgeGroupsCRM] = useState([]);
    const [select, setSelect] = useState(null);
    const [selectCRM, setSelectCRM] = useState(null);
    const [checkbox, setCheckbox] = useState(false);

    const [mainName, setMainName] = useState("");
    const [shortName, setShortName] = useState("");
    const [menName, setMenName] = useState("");
    const [femaleName, setFemaleName] = useState("");
    const [displayedValue, setDisplayedValue] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [visualRemoveAgeGroup, setVisualRemoveAgeGroup] = useState(false);
    const [visualAddAgeGroup, setVisualAddAgeGroup] = useState(false);
    const [open, setOpen] = useState(false);

    const getAgeGroups = async () => {
        const res = await api().get("/judge/age-groups");
        if (res?.data?.status === 'ok') {
            setAgeGroups(res?.data.age_group);
        }
    }

    const getAgeGroupsCRM = async () => {
        const res = await api().get("/competition/age-groups-crm");
        const sortedData = [...res.data].sort((a, b) =>
            Number(a.age_group_id) - Number(b.age_group_id)
        );
        setAgeGroupsCRM(sortedData);
    }

    useEffect(() => {
        getAgeGroups().then();
        getAgeGroupsCRM().then();
    }, []);

    const handleKeyDown = (e) => {
        const {key, keyCode} = e;

        if (keyCode >= 9 && keyCode <= 45 || keyCode >= 112 && keyCode <= 123) {
            return;
        }

        if (key === 'Backspace') {
            setDisplayedValue((prev) => prev.slice(0, -1));
        } else if (key.length === 1) {
            setDisplayedValue((prev) => prev + key);
        }
    };

    const deleteAgeGroupHandler = async () => {
        setVisualRemoveAgeGroup(true);
        if (select === null) {
            toast.error("Выберите возрастную группу для удаления!")
        } else if (displayedValue === '') {
            toast.error("Введите пароль!")
        } else {
            const res = await api().delete(`/competition/delete-age-group/${select}`, {
                data: {
                    password: displayedValue
                }
            });

            if (res?.data?.status === 'ok') {
                setShowPassword(false);
                setSelect(null);
                setDisplayedValue('');
                getAgeGroups().then(() => {
                });
                toast.success("Возрастная группа успешна удалена!")
            } else {
                toast.error(res?.data?.msg)
            }
        }
        setVisualRemoveAgeGroup(false);
    }

    const addAgeGroupHandler = async () => {
        setVisualAddAgeGroup(true);
        if (select === null) {
            toast.error("Выберите шаблон возрастной группы!");
        } else if (mainName === '') {
            toast.error("Введите название возрастной группы!");
        } else if (shortName === '') {
            toast.error("Введите короткое название возрастной группы!");
        } else if (menName === '') {
            toast.error("Введите название для мужского пола!");
        } else if (femaleName === '') {
            toast.error("Введите название для женского пола!");
        } else if (selectCRM === null && !checkbox) {
            toast.error("Введите ID возрастной группы в ЛК!");
        } else {

            try {
                const res = await api().post(`/competition/create-age-group`, {
                    age_group_id: select,
                    age_group_name: mainName,
                    short_name: shortName,
                    men_name: menName,
                    female_name: femaleName,
                    crm_id: selectCRM,
                    is_discipline_create: checkbox
                });

                if (res?.data?.status === 'ok') {
                    setSelect(null);
                    setMainName('');
                    setMenName('');
                    setShortName('');
                    setFemaleName('');
                    setSelectCRM(null);
                    getAgeGroups();

                    toast.success("Возрастная группа успешно создана!");
                } else {
                    toast.error(res?.data?.msg || 'Неизвестная ошибка');
                }
            } catch (error) {
                let errorMsg = 'Произошла ошибка при создании группы';

                if (error.response?.data?.msg) {
                    errorMsg = error.response.data.msg;
                } else if (error.response?.data?.message) {
                    errorMsg = error.response.data.message;
                } else if (error.message) {
                    errorMsg = error.message;
                }

                toast.error(errorMsg);
            }
        }
        setVisualAddAgeGroup(false);
    }

    return (
        <div className={s.content} style={{borderLeft: '1px solid rgb(221, 221, 221)'}}>
            <div style={{display: "flex", flexDirection: 'column', alignItems: 'center', position: 'relative'}}>
                <div
                    onClick={() => setOpen(prev => !prev)}
                    style={{
                        border: '2px solid #58A2E4',
                        color: '#58A2E4',
                        borderRadius: '3px',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        paddingTop: '2px',
                        width: '25px',
                        cursor: 'pointer',
                        height: '25px',
                        position: 'absolute',
                        top: '-30px',
                        right: '-30px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: "center"
                    }}>i
                    {open && (
                        <div className={s.tooltip}>
                            1. Создание возрастной группы связанной с ЛК.<br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;a) Выберите шаблон возрастной группы.</i><br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;b) Введите все названия.</i><br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;c) Выберите возрастную группу в ЛК (для связки).</i><br/>
                            2. Создание возрастной группы с тестовой дисциплиной.<br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;a) Выберите шаблон возрастной группы.</i><br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;b) Введите все названия.</i><br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;c) Включите галочку 'Создать дисциплину для теста'.</i><br/>
                            3. Удаление возрастной группы.<br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;a) Выберите шаблон возрастной группы.<br/> (кроме основных их удалить невозможно).</i><br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;b) Введите пароль в текстовое поле.</i><br/>
                            <i>&nbsp;&nbsp;&nbsp;&nbsp;b) Нажмите кнопку удалить.</i><br/><br/>
                            ВНИМАНИЕ создание возрастной группы связанной с ЛК и дисциплины для теста одновременно невозможно.<br/>
                            Делайте это по очереди!
                            <p style={{color: 'red'}}>После создания/удаления возрастной группы обновите страницу (или нажмите F5) для обновления списка дисциплин.</p>
                        </div>
                    )}
                </div>

                <h1 style={{marginBottom: "20px"}}>Добавление возрастной группы</h1>
                <Select
                    placeholder={'Шаблон возрастной группы'}
                    displayEmpty
                    value={select}
                    onChange={(e) => {
                        setSelect(e.target.value)
                    }}
                    inputProps={{'aria-label': 'Without label'}}
                    sx={{
                        height: '33px',
                        width: '280px',
                        backgroundColor: '#fff'
                    }}
                    labelId="demo-simple-select-label">

                    <MenuItem sx={{
                        display: 'none'
                    }} hidden disabled selected value={null}>Шаблон возрастной группы</MenuItem>
                    {ageGroups.map((el) => <MenuItem key={el.age_group_id}
                                                     value={el.age_group_id}>{`${el.age_group_name}`}</MenuItem>)}

                </Select>

                <input className={s.input} type="text" placeholder={"Название возрастной группы"} value={mainName}
                       style={{width: '250px', marginTop: '19px'}}
                       onChange={(e) => setMainName(e.target.value)}/>
                <input className={s.input} type="text" placeholder={"Короткое название"} value={shortName}
                       style={{width: '250px'}}
                       onChange={(e) => setShortName(e.target.value)}/>
                <input className={s.input} type="text" placeholder={"Название для мужского пола"}
                       value={menName} style={{width: '250px'}}
                       onChange={(e) => setMenName(e.target.value)}/>
                <input className={s.input} type="text" placeholder={"Название для женского пола"}
                       value={femaleName} style={{width: '250px'}}
                       onChange={(e) => setFemaleName(e.target.value)}/>

                <div style={{
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '300px',
                    fontSize: '14px'
                }}>
                    <Checkbox onChange={(e) => {
                        setCheckbox(e.target.checked);
                        if (e.target.checked) {
                            setSelectCRM(null);
                        }
                    }}/><span>Создать дисциплину для теста</span>
                </div>

                <Select
                    placeholder={'ID возрастной группы в ЛК'}
                    displayEmpty
                    value={selectCRM}
                    onChange={(e) => {
                        setSelectCRM(e.target.value)
                    }}
                    disabled={checkbox}
                    inputProps={{'aria-label': 'Without label'}}
                    sx={{
                        height: '33px',
                        width: '250px',
                        backgroundColor: '#fff',
                        fontSize: '14px',
                        marginBottom: '30px'
                    }}
                    MenuProps={{
                        sx: {
                            '& .MuiMenuItem-root': {
                                fontSize: '13px',
                                padding: '6px 16px',
                                minHeight: '32px',
                            },
                        },
                    }}
                    labelId="demo-simple-select-label">

                    <MenuItem sx={{
                        display: 'none'
                    }} hidden disabled selected value={null}>Возрастная группа в ЛК</MenuItem>
                    {ageGroupsCRM.map((el) => <MenuItem key={el.age_group_id}
                                                        value={el.age_group_id}>{`${el.age_group_name}`}</MenuItem>)}

                </Select>

                <div style={{marginTop: '0'}} className={s.button} onClick={addAgeGroupHandler}>Добавить
                    {visualAddAgeGroup &&
                        <CircularProgress style={{position: "absolute", marginLeft: "179px", marginTop: "13px"}}
                                          size="12px" color="inherit"/>}
                </div>
                <span style={{fontSize: '12px', marginTop: '20px'}}>Удалить выбранный шаблон возрастной группы?</span>
                <div style={{display: "flex", justifyContent: 'space-between', width: '250px'}}>
                    <div style={{width: '120px', position: 'relative'}}>
                        <input
                            className={s.input}
                            type="text"
                            placeholder="Пароль"
                            value={showPassword ? displayedValue : '*'.repeat(displayedValue.length || 0)}
                            style={{width: '100%', paddingRight: '30px'}}
                            onKeyDown={handleKeyDown}
                            onChange={() => {
                            }}
                        />
                        <span
                            style={{
                                position: 'absolute',
                                right: '5px',
                                top: '38%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                            }}
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                        >
                            <img
                                src={showPassword ? openEye : closeEye}
                                alt={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                                width="18"
                                height="18"
                            />
                        </span>
                    </div>
                    <div style={{width: '110px', marginTop: '0', background: 'red'}} className={s.buttonDel}
                         onClick={deleteAgeGroupHandler}>Удалить
                        {visualRemoveAgeGroup &&
                            <CircularProgress style={{position: "absolute", marginLeft: "89px", marginTop: "13px"}}
                                              size="12px" color="inherit"/>}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AgeGroupAddition;